/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,

} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import ViewAIHub from "../../Modals/aiHub";

import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import StarsOutlinedIcon from "@mui/icons-material/StarsOutlined";
import CreditScoreOutlinedIcon from "@mui/icons-material/CreditScoreOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

const VendorCredits = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const orderData = [
        {
            vendorId: "3d200702-1ac3-4984-b166-92d77806c0c",
            tier: "enterprise",
            totalCredits: "10,000",
            consumed: "7,800",
            remaining: "2,200",
            bonus: "+500",
            status: "active",
            resetDate: "1/6/2026",
        },
        {
            vendorId: "fd8c10f7-5886-4cec-8635-5d118594fc62",
            tier: "enterprise",
            totalCredits: "10,000",
            consumed: "6,520",
            remaining: "3,480",
            bonus: "+500",
            status: "active",
            resetDate: "1/6/2026",
        },
        {
            vendorId: "0f0baf4a-a2e5-4ad2-bc08-8946270c1229",
            tier: "enterprise",
            totalCredits: "10,000",
            consumed: "4,200",
            remaining: "5,800",
            bonus: "+500",
            status: "active",
            resetDate: "1/6/2026",
        },
        {
            vendorId: "1de11be5-6a4a-4d26-93cd-76f91c5a346a",
            tier: "pro",
            totalCredits: "2,000",
            consumed: "2,150",
            remaining: "-150",
            bonus: "-",
            status: "overlimit",
            resetDate: "1/6/2026",
        },
        {
            vendorId: "da916880-a7e4-420c-a826-1d79171289de",
            tier: "pro",
            totalCredits: "2,000",
            consumed: "1,950",
            remaining: "50",
            bonus: "-",
            status: "active",
            resetDate: "1/6/2026",
        },
    ];



    return (
        <>
            <div className="main_title">
                <h1>Vendor AI Credits</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Vendor AI Credits
                </p>
            </div>
            <div className="stats_boxes gap_m">

                {/* Total Vendors */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            10
                            <p>Total Vendors</p>
                        </h2>
                        <figure className="blue">
                            <BusinessOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight neutral">
                        <span>All active vendors</span>
                    </div>
                </a>

                {/* Enterprise Plans */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            3
                            <p>Enterprise Plans</p>
                        </h2>
                        <figure className="purple">
                            <StarsOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight positive">
                        <span>Highest usage tier</span>
                    </div>
                </a>

                {/* Total Credits Issued */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            30,500
                            <p>Total Credits Issued</p>
                        </h2>
                        <figure className="green">
                            <CreditScoreOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight positive">
                        <span>Across all vendors</span>
                    </div>
                </a>

                {/* Overlimit Vendors */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            1
                            <p>Overlimit Vendors</p>
                        </h2>
                        <figure className="warning">
                            <WarningAmberOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight negative">
                        <span>Needs review</span>
                    </div>
                </a>

            </div>




            <div className="cards mt_20">
                <div className="table_header">
                    <div className="left_s">
                        <Box className="search_box">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search..."
                            />
                        </Box>
                    </div>
                    <div className="right_s">
                        <div className="form">
                            <div className="control_group">
                                <input type="date" />
                            </div>

                        </div>
                    </div>

                </div>

                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Vendor ID</TableCell>
                                <TableCell>Subscription Tier</TableCell>
                                <TableCell>Total Credits</TableCell>
                                <TableCell>Consumed</TableCell>
                                <TableCell>Remaining</TableCell>
                                <TableCell>Bonus</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Reset Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {orderData.map((item, index) => (
                                <TableRow key={index} hover>

                                    <TableCell>{item.vendorId}</TableCell>

                                    <TableCell>
                                        <span className={`badge1 ${item.tier}`}>
                                            {item.tier}
                                        </span>
                                    </TableCell>

                                    <TableCell>{item.totalCredits}</TableCell>

                                    <TableCell className="text_danger fw_600">
                                        {item.consumed}
                                    </TableCell>

                                    <TableCell className="text_success fw_600">
                                        {item.remaining}
                                    </TableCell>

                                    <TableCell>{item.bonus}</TableCell>

                                    <TableCell>
                                        <span className={`badge1 ${item.status}`}>
                                            {item.status}
                                        </span>
                                    </TableCell>

                                    <TableCell>{item.resetDate}</TableCell>


                                </TableRow>
                            ))}
                        </TableBody>



                    </Table>
                </TableContainer>
            </div>


            <ViewAIHub
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default VendorCredits;
